import { useState, useEffect, useRef } from 'react';
import React, { useParams } from 'react-router-dom';
import axios from 'axios';

const EnableRSVP = () => {
  const { id } = useParams();
  const [isRsvpEnabled, setIsRsvpEnabled] = useState(true);
  const [emailEnabled, setEmailEnabled] = useState(true);
  const [limitRsvp, setLimitRsvp] = useState('');
  const [inputValue, setInputValue] = useState(''); // New state for input value
  const [alert, setAlert] = useState(null);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_BASE_URL}/clients/${id}`)
      .then(response => {
        const rsvpStatus = JSON.parse(response.data.rsvp);
        setIsRsvpEnabled(rsvpStatus);
        setEmailEnabled(response.data.email_input);
        setLimitRsvp(response.data.limit_rsvp ?? 0);
        setInputValue(response.data.limit_rsvp ?? 0); // Initialize input value
      })
      .catch(() => {
        showAlert('error', 'Gagal memuatkan data.');
      });
  }, []);

  const showAlert = (type, message) => {
    setAlert({ type, message });
    setTimeout(() => setAlert(null), 3000);
  };

  const toggleRsvp = () => {
    axios.put(`${process.env.REACT_APP_API_BASE_URL}/update-rsvp/${id}`, { rsvp: !isRsvpEnabled })
      .then(() => {
        setIsRsvpEnabled(!isRsvpEnabled);
        window.location.reload();
      })
      .catch(() => {
        showAlert('error', 'Gagal mengemaskini RSVP.');
      });
  };

  const toggleEmail = () => {
    axios.put(`${process.env.REACT_APP_API_BASE_URL}/update-emailinput/${id}`, { email_input: !emailEnabled })
      .then(() => {
        setEmailEnabled(!emailEnabled);
        window.location.reload();
      })
      .catch(() => {
        showAlert('error', 'Gagal mengemaskini tetapan email.');
      });
  };

  const handleInputChange = (e) => {
    const input = e.target.value;
    if (/^\d*$/.test(input) && parseInt(input || '0') <= 100) {
      setInputValue(input);
    }
  };

  const applyLimitChange = () => {
    const limit = inputValue === '' ? 0 : parseInt(inputValue);
    axios.put(`${process.env.REACT_APP_API_BASE_URL}/update-limit-rsvp/${id}`, {
      limit_rsvp: limit,
    })
      .then(() => {
        showAlert('success', `Had tetamu telah dikemaskini kepada ${limit}.`);
        setLimitRsvp(limit);
      })
      .catch(() => {
        showAlert('error', 'Gagal mengemaskini had tetamu.');
      });
  };

  return (
    <div className="mb-8 space-y-5">

      {/* Alert */}
      {alert && (
        <div className={`p-3 rounded-md shadow-md transition-all duration-300 text-sm
          ${alert.type === 'success'
            ? 'bg-green-100 text-green-800 border border-green-300'
            : 'bg-red-100 text-red-800 border border-red-300'
          }`}
        >
          {alert.message}
        </div>
      )}

      {/* RSVP Toggle */}
      <div className="flex items-center">
        <h1 className='text-black font-bold'>Aktifkan RSVP?</h1>
        <input
          type="checkbox"
          checked={isRsvpEnabled}
          onChange={toggleRsvp}
          id="rsvpToggle"
          className="hidden"
        />
        <label
          htmlFor="rsvpToggle"
          className="flex items-center cursor-pointer bg-gray-100 w-14 h-7 rounded-full p-1 border border-gray-300 transition duration-300 ease-in-out ml-auto"
        >
          <div
            className={`${
              isRsvpEnabled ? 'translate-x-7 bg-green-500' : 'translate-x-0 bg-gray-400'
            } w-5 h-5 rounded-full shadow-md transform transition-transform`}
          ></div>
        </label>
      </div>

      {/* Email Toggle */}
      <div className="flex items-center">
        <h1 className='text-black font-bold'>Perlukan email tetamu?</h1>
        <input
          type="checkbox"
          checked={emailEnabled}
          onChange={toggleEmail}
          id="emailToggle"
          className="hidden"
        />
        <label
          htmlFor="emailToggle"
          className="flex items-center cursor-pointer bg-gray-100 w-14 h-7 rounded-full p-1 border border-gray-300 transition duration-300 ease-in-out ml-auto"
        >
          <div
            className={`${
              emailEnabled ? 'translate-x-7 bg-green-500' : 'translate-x-0 bg-gray-400'
            } w-5 h-5 rounded-full shadow-md transform transition-transform`}
          ></div>
        </label>
      </div>

      {/* Limit RSVP Input */}
      <div className="flex items-center justify-between pt-4">
        <div>
          <h1 className="text-black font-bold">Had Tetamu RSVP Untuk Setiap Jemputan</h1>
          <p className='text-sm text-gray-500'>Tetapkan 0 untuk tiada had tetamu</p>
        </div>
        <div className='flex flex-col space-y-2 items-center'>
          <input
            type="number"
            min={0}
            max={100}
            value={inputValue}
            onChange={handleInputChange}
            className="ml-auto w-20 border rounded p-1 text-right"
            placeholder="0"
          />
          <button
            onClick={applyLimitChange}
            className="ml-2 px-3 py-1 btn-primary text-white rounded"
          >
            Apply
          </button>
        </div>
      </div>
    </div>
  );
};

export default EnableRSVP;
